import { DateField, DropdownField, IntField, StringField } from './fields';

export type NoErrorType = false;
export const NO_ERROR: NoErrorType = false;
export interface IValidationErrorData {
    limit?: number;
    max?: number;
    min?: number;
}
export interface IValidationError {
    message: string;
    data?: IValidationErrorData;
}

export interface IValidator<T> {
    (value: T): NoErrorType | IValidationError;
}

export interface IValidatorFactory<T, N> {
    (rule: T): IValidator<N>;
}

export type IFieldTypes = typeof IntField | typeof DateField | typeof StringField | typeof DropdownField;
